<template>
    <section class="restaurant-detail">
        <h3 v-test:title>{{ title }}</h3>

        <slot />
    </section>
</template>

<script>
    export default {
        name: 'restaurant-detail',

        props: {
            title: {
                type: String,
                required: true,
            },
        },
    };
</script>

<style lang="scss" scoped>
    .restaurant-detail {
        font-size: rem(18px);
    }

    h3 {
        color: $primary;
        font-size: rem(24px);
        font-weight: bold;
    }

    ::v-deep p:last-child {
        margin-bottom: 0;
    }
</style>
